import React from 'react';
import {useRouter} from 'next/router';

import CertificatePage from '../../../js/pages/CertificatePage';
import NotFoundPage from '../../404';

import certificates from '../../../js/constants/certificates';

export default function Page() {
  const router = useRouter();
  const {slug} = router.query;
  const certificate = certificates[slug];
  if (!certificate) return <NotFoundPage />;

  return <CertificatePage slug={slug} />;
}


